import React from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  return (
    <nav className="flex flex-wrap gap-2 p-4 bg-black text-white">
      <Link to="/" className="font-bold text-purple-400 hover:underline">🔥 IAdeportiva</Link>
      <Link to="/live" className="hover:underline">👁️ En Vivo</Link>
      <Link to="/statistics" className="hover:underline">📊 Estadísticas</Link>
      <Link to="/results" className="hover:underline">📈 Resultados</Link>
      <Link to="/nba" className="hover:underline">🏀 NBA</Link>
      <Link to="/mlb" className="hover:underline">⚾ MLB</Link>
      <Link to="/nfl" className="hover:underline">🏈 NFL</Link>
      <Link to="/nhl" className="hover:underline">🏒 NHL</Link>
      <Link to="/ncaaf" className="hover:underline">🎓 NCAAF</Link>
      <Link to="/ncaam" className="hover:underline">🎓 NCAAM</Link>
      <Link to="/register" className="ml-auto border px-2 py-1 rounded">👥 Registrarse</Link>
    </nav>
  );
}
